export const AmebaFlg = [
  { label: '対象外', value: '0' },
  { label: '対象', value: '1' },
];
